import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { InsuranceDocService } from '../_services';
import * as InsuranceDocActions from '../_actions/insuranceDoc';

@Injectable({
  providedIn: 'root',
})
export class InsuranceDocEffects {
  loadInsuranceDocs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InsuranceDocActions.loadInsuranceDocs),
      mergeMap(() =>
        this.insuranceDocService.getInsuranceDocs().pipe(
          map((insuranceDocs) => InsuranceDocActions.loadInsuranceDocsSuccess({ insuranceDocs })),
          catchError((error) => of(InsuranceDocActions.loadInsuranceDocsFailure({ error })))
        )
      )
    )
  );

  addInsuranceDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InsuranceDocActions.addInsuranceDoc),
      mergeMap(({ insuranceDoc }) =>
        this.insuranceDocService.saveInsuranceDoc(insuranceDoc).pipe(
          map((savedInsuranceDoc) =>
            InsuranceDocActions.addInsuranceDocSuccess({ insuranceDoc: savedInsuranceDoc })
          ),
          catchError((error) => of(InsuranceDocActions.addInsuranceDocFailure({ error })))
        )
      )
    )
  );

  updateInsuranceDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InsuranceDocActions.updateInsuranceDoc),
      mergeMap(({ insuranceDoc }) =>
        this.insuranceDocService.saveInsuranceDoc(insuranceDoc).pipe(
          map((updatedInsuranceDoc) =>
            InsuranceDocActions.updateInsuranceDocSuccess({ insuranceDoc: updatedInsuranceDoc })
          ),
          catchError((error) => of(InsuranceDocActions.updateInsuranceDocFailure({ error })))
        )
      )
    )
  );

  deleteInsuranceDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InsuranceDocActions.deleteInsuranceDoc),
      mergeMap(({ id }) =>
        this.insuranceDocService.deleteInsuranceDoc(id).pipe(
          map(() => InsuranceDocActions.deleteInsuranceDocSuccess({ id })),
          catchError((error) => of(InsuranceDocActions.deleteInsuranceDocFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private insuranceDocService: InsuranceDocService
  ) {}
}
